var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsSplat1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 853,
    height: 1677,
    viewBox: "0 0 853 1677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_889_3395)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7875 469.31C103.455 481.268 175.99 464.398 240.049 494.271C309.555 526.683 371.398 576.933 408.483 644.041C447.109 713.937 452.333 795.139 450.432 874.968C448.324 963.47 474.357 1086.66 396.917 1129.61C308.655 1178.57 204.181 1037.02 107.288 1065.3C10.6505 1093.52 -3.5343 1298.96 -101.332 1275.07C-196.71 1251.78 -123.645 1079.67 -175.384 996.262C-214.288 933.541 -330.09 940.967 -352.237 870.567C-373.8 802.022 -296.517 742.368 -277.01 673.21C-252.628 586.769 -298.761 463.958 -223.646 414.679C-148.791 365.57 -54.458 454.163 33.7875 469.31Z",
    fill: "url(#paint0_linear_889_3395)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_889_3395",
    x: -756,
    y: 0,
    width: 1609,
    height: 1677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_889_3395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_889_3395",
    x1: -419.993,
    y1: 1369.58,
    x2: 527.307,
    y2: 436.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#D05731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsSplat1);
export default __webpack_public_path__ + "static/media/about_us_splat_1.56eb3d2ea1b996bcfa24b907f60fdea6.svg";
export { ForwardRef as ReactComponent };